<template>
  <v-dialog v-model="toggle" max-width="500" persistent>
    <v-card
      class="pa-5"
    >
      <v-card-text class="mb-5">
        <h1 class="primary--text pb-5 pt-5">Thank you!</h1>
        <h3>You successfully submitted your billing information. Please wait for our agent to call you regarding payment.</h3>
      </v-card-text>

      <v-card-actions>
        <div class="mx-auto">
          <router-link to="/shop">
            <base-button
              x-large
              name="Back to shop"
              icon="mdi-arrow-left"
            >
            </base-button>
          </router-link>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "BillSuccessDialog",

    props: {
      value: { type: Boolean, default: false }
    },

    data() {
      return {
        toggle: this.value
      }
    },

    watch: {
      value(val) {
        this.toggle = val;
      },
      toggle(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>